import { markInputRule } from '@tiptap/core';
import Strike from '@tiptap/extension-strike';

const CustomStrike = Strike.extend({
  // Override renderHTML to ensure consistent HTML output
  renderHTML() {
    return ['s', 0];
  },

  // Override addInputRules to use single tilde
  addInputRules() {
    return [
      markInputRule({
        find: /(?:^|\s)(~(?!\s)((?:[^~]+))~)$/, // Modified regex for single tilde
        type: this.type,
      }),
    ];
  },
});

export default CustomStrike;
